import { initialState } from "./state";

export const setNotifications = (state, payload) => {
  state.notifications = payload;
};

export const reset = (state) => {
  const s = initialState();

  Object.keys(s).forEach((key) => {
    state[key] = s[key];
  });
};
